import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {AlarmEvent} from '../../../../shared/models/alarm';
import {OptionGroup} from '../../../../shared/models/option';
import {PopoverMenuComponent} from '../../popover-menu/popover-menu.component';

@Component({
  selector: 'motn-tile-alarm-badge',
  templateUrl: './tile-alarm-badge.component.html',
  styleUrls: ['./tile-alarm-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    PopoverMenuComponent,
  ],
})
export class TileAlarmBadgeComponent implements OnInit {
  @Input() alarmEvent: AlarmEvent;
  @Input() alarmMenuOptions: OptionGroup;

  @Output() clickedAfterRender: EventEmitter<null> = new EventEmitter<null>();


  constructor() {
  }


  ngOnInit(): void {
  }


  emitClicked() {
    this.clickedAfterRender.emit(null);
  }
}
